export default class ArticleEntity {
  articleId: string = "";

  sectionId: string = "";

  createdByUserId: string = "";

  articleName: string = "";

  articleDate: string = "";

  articleHtml: string = "";

  DisplayOrder: number = 0;

  visible: boolean = true;
}
